import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material'
import { TBasicListItem } from '../../../utils/types/layoutTypes'
import { useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../../context/auth/AuthContextProvider'

const BasicListItem = ({
  index,
  selected,
  listItem,
  navMenuOpen,
}: TBasicListItem) => {
  const { user } = useAuthContext()
  const navigate = useNavigate()

  const iconMinWidth = user.companyOptions.includes('MENU_JOBS_STATUS')
    ? '40px'
    : '56px'

  return (
    <Tooltip
      key={index}
      title={`${navMenuOpen ? '' : listItem.label}`}
      placement="right"
    >
      <ListItemButton
        selected={selected}
        onClick={() => navigate(listItem.goToUrl)}
      >
        <ListItemIcon sx={{ color: 'var(--white)', minWidth: iconMinWidth }}>
          {listItem.icon}
        </ListItemIcon>
        <ListItemText primary={listItem.label} />
      </ListItemButton>
    </Tooltip>
  )
}

export default BasicListItem
